// extracted by mini-css-extract-plugin
module.exports = {"root":"Errors_root__eGkCu","errors":"Errors_errors__22cx_"};